import React from 'react';
import Header from './Header'
import Footer from './Footer'
import PushMenu from '../Presentation/PushMenu'

import DocumentTitle from 'react-document-title';
import buildTitle from '../../utils/TitleBuilder';

export default class Page extends React.Component {
    render() {
        return <DocumentTitle title={buildTitle(this.props.title)} className="transition-item">
            <div>
                <PushMenu />
                <div className="main-wrapper">
                    <Header />
                    <div className="transition-page">
                        {this.props.children}
                    </div>
                    {this.props.hideFooter ? null : <Footer />}
                </div>
            </div>
        </DocumentTitle>
    }
}


// WEBPACK FOOTER //
// ./src/components/Containers/Page.js